// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { ClaimItemDocumentDTO } from './claim-item-document-dto';
import { ClaimItemProposalDTO } from './claim-item-proposal-dto';

/**
 * 
 * @export
 * @interface ClaimItemDTO
 */
export interface ClaimItemDTO {
    /**
     * 
     * @type {string}
     * @memberof ClaimItemDTO
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimItemDTO
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimItemDTO
     */
    claimId: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimItemDTO
     */
    type: ClaimItemDTOTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ClaimItemDTO
     */
    originalAmount: number;
    /**
     * 
     * @type {Array<ClaimItemDocumentDTO>}
     * @memberof ClaimItemDTO
     */
    claimItemDocuments?: Array<ClaimItemDocumentDTO>;
    /**
     * 
     * @type {Array<ClaimItemProposalDTO>}
     * @memberof ClaimItemDTO
     */
    proposals?: Array<ClaimItemProposalDTO>;
    /**
     * 
     * @type {string}
     * @memberof ClaimItemDTO
     */
    deletedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimItemDTO
     */
    createdAt: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ClaimItemDTOTypeEnum {
    DAMAGE = 'DAMAGE',
    CLEANING = 'CLEANING',
    RENTARREARS = 'RENT_ARREARS',
    ITEMREMOVAL = 'ITEM_REMOVAL',
    OTHER = 'OTHER'
}



